import * as Sentry from '@sentry/react';
import {
  isSentryCaptured,
  isSentryInitialized,
  markSentryCaptured,
  normalizeError,
} from '@payler/sentry/merchant-cabinet';

export function captureHookError(error: unknown, where: string): void {
  if (!isSentryInitialized()) return;
  if (isSentryCaptured(error)) return;

  try {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      scope.setTag('error.kind', 'hook_error');
      scope.setTag('hook.where', where);
      Sentry.captureException(normalizeError(error));
    });

    markSentryCaptured(error, 'hook');
  } catch {
    // never break app flow
  }
}

